import type { DateFormatter } from '@internationalized/date';
import type { SearchResultItem } from '../types';

const MAXIMUM_DESCRIPTION_SIZE = 50;

const truncateText = (text: string, length: number = MAXIMUM_DESCRIPTION_SIZE): string =>
  text.length > length ? `${text.substring(0, length)}...` : text;

export const getSectionName = (resultItem: SearchResultItem): string => {
  if (resultItem.type === 'guide_task') {
    const sectionName = resultItem?.guide?.section?.name;
    return sectionName ? truncateText(sectionName) : null;
  }
  return null;
};

export const getResultInfo = (resultItem: SearchResultItem, dateFormatter: DateFormatter): string => {
  const date = dateFormatter.format(new Date(resultItem.updatedDate));
  const updatedInfo = `Updated ${date}`;
  const updateBy = resultItem.updatedBy.name ? ` ${resultItem.updatedBy.name}` : '';

  if (resultItem.type === 'guide_task') {
    const sectionName = resultItem.guide.section.name;
    return `${truncateText(sectionName)} • ${updatedInfo}${updateBy}`;
  }
  return `${updatedInfo}${updateBy}`;
};
